
interface SelectOption {
  value: string | boolean
  label: string
}

export const getSelectLabel = (valueList: readonly SelectOption[], value?: string): string => {
  const item = valueList.find((v) => v.value === value);
  return item ? item.label : '-';
}; 

export const YES_OR_NO = [
  {value: '1', label: 'Evet'},
  {value: '0', label: 'Hayır'},
] as const

export const IS_OR_NO = [
  {value: '1', label: 'Var'},
  {value: '0', label: 'Yok'},
] as const

export const ACTIVE_OR_PASSIVE = [
  {value: '1', label: 'Aktif'},
  {value: '0', label: 'Pasif'},
] as const

export const OPEN_OR_CLOSE = [
  {value: '1', label: 'Açık'},
  {value: '0', label: 'Kapalı'},
] as const

export const FUEL_TYPES = [
  {value: '0', label: 'Dizel'},
  {value: '1', label: 'Benzinli'},
  {value: '2', label: 'Kurşunsuz'},
  {value: '3', label: 'LPG'},
  {value: '4', label: 'Elektrik'},
  {value: '5', label: 'Hybrid'},
  {value: '6', label: 'LPG-Benzin'},
] as const

export const BILL_PERIOD = [
  {value: '0', label: 'Günlük'},
  {value: '1', label: 'Aylık'},
] as const

export const BILL_PROFILE = [{value: '0', label: 'Profil Yok'}] as const

export const RETURN_REASON = [
  {value: '0', label: 'Dönemsel İhtiyacın Sonlanması'},
  {value: '1', label: 'Küçülme/Finansal Zorluk'},
  {value: '2', label: 'EA dan Vazgeçiş'},
  {value: '3', label: 'Rakipten EA Kiralama'},
  {value: '4', label: 'EA Satınalma'},
  {value: '5', label: 'Uzatma'},
  {value: '6', label: 'Yenileme'},
] as const

export const RISK_LEVEL = [
  {value: '0', label: 'Normal'},
  {value: '1', label: 'Düşük'},
  {value: '2', label: 'Yüksek'},
] as const

export const TRANSMISSION_TYPES = [
  {value: '0', label: 'Manuel'},
  {value: '1', label: 'Otomatik'},
  {value: '2', label: 'Yarı Otomatik'},
  {value: '3', label: 'CVT (Sürekli Değişken Vites)'},
  {value: '4', label: 'Çift Kavrama'},
  {value: '5', label: 'Tiptronic'},
] as const

export const OPTION_TYPES = [
  {value: '0', label: 'Net'},
  {value: '1', label: 'Opsiyonlu'},
  {value: '2', label: 'Taahütlü'},
] as const

export const BODY_TYPES = [
  {value: '0', label: 'Sedan'},
  {value: '1', label: 'Hatchback'},
  {value: '2', label: 'SUV'},
  {value: '3', label: 'Crossover'},
  {value: '4', label: 'Coupe'},
  {value: '5', label: 'Cabriolet / Convertible'},
  {value: '6', label: 'Pick-up'},
  {value: '7', label: 'Van'},
  {value: '8', label: 'Minivan'},
  {value: '9', label: 'Station Wagon'},
  {value: '10', label: 'Roadster'},
  {value: '11', label: 'Limuzin'},
] as const

export const FUEL_LEVEL = [
  {value: '0', label: '0'},
  {value: '1', label: '1'},
  {value: '2', label: '2'},
  {value: '3', label: '3'},
  {value: '4', label: '4'},
  {value: '5', label: '5'},
  {value: '6', label: '6'},
  {value: '7', label: '7'},
  {value: '8', label: '8'},
] as const

export const CLEANS = [
  {value: '0', label: 'Kirli'},
  {value: '1', label: 'Temiz'},
  {value: '2', label: 'Yıkama'},
] as const

export const LICENSE_TYPES = [
  {value: '0', label: 'Türk Ehliyeti'},
  {value: '1', label: 'Yabancı-Yabancı Ehliyeti'},
  {value: '2', label: 'Türk Yabancı Ehliyeti'},
] as const

export const HGS_TYPES = [
  {value: '0', label: 'Varsayılan'},
  {value: '1', label: 'Ayrı'},
  {value: '2', label: 'Sadece Kapanınca Ayrı'},
] as const

export const LANGUAGE = [
  {value: '0', label: 'TR'},
  {value: '1', label: 'EN'},
  {value: '2', label: 'Diğer'},
] as const

export const INVOICE_TYPES = [
  {value: '0', label: 'Kira Bitişi'},
  {value: '1', label: 'Kira Başlangıcı'},
  {value: '2', label: 'Ay Sonu'},
  {value: '3', label: 'Ayın 1. Günü'},
  {value: '4', label: 'Mutabakat Üzerine'},
  {value: '5', label: 'Rezervasyon Baz Al'},
] as const

export const LICENSE_CLASS = [
  {value: 'A1', label: 'A1'},
  {value: 'A2', label: 'A2'},
  {value: 'A', label: 'A'},
  {value: 'B1', label: 'B1'},
  {value: 'B', label: 'B'},
  {value: 'BE', label: 'BE'},
  {value: 'C1', label: 'C1'},
  {value: 'C1E', label: 'C1E'},
  {value: 'C', label: 'C'},
  {value: 'CE', label: 'CE'},
  {value: 'D1', label: 'D1'},
  {value: 'D1E', label: 'D1E'},
  {value: 'D', label: 'D'},
  {value: 'DE', label: 'DE'},
] as const

export const CUSTOMER_CLASS = [
  {value: '0', label: 'Düşük'},
  {value: '1', label: 'Orta'},
  {value: '2', label: 'Personel'},
  {value: '3', label: 'Problemli'},
  {value: '4', label: 'VIP'},
  {value: '5', label: 'Yüksek'},
] as const

export const CUSTOMER_TYPES = [
  {value: '0', label: 'Yurtiçi'},
  {value: '1', label: 'Yurtdışı'},
  {value: '2', label: '2. El'},
  {value: '3', label: 'Grup İçi'},
] as const

export const STOPPAGE_TYPES = [
  {value: '0', label: 'Serbest'},
  {value: '1', label: 'Sadece Tevkifatsız'},
  {value: '2', label: 'Sadece Tefkifatlı'},
] as const

export const RISK_TYPES = [
  {value: '0', label: 'Normal'},
  {value: '1', label: 'İzinli'},
] as const

export const RESERVATION_STATUS = [
  {value: '0', label: 'Rezervasyon'},
  {value: '1', label: 'Gerçekleşti'},
  {value: '2', label: 'İptal'},
  {value: '3', label: 'No Show'},
] as const

export const RENT_STATUS = [
  {value: '0', label: 'Kirada'},
  {value: '1', label: 'Döndü '}, 
  {value: '2', label: 'İptal'},
] as const

export const VISIBLE_OR_NOT = [
  {value: '1', label: 'Görünsün'},
  {value: '0', label: 'Görünmesin'},
] as const

export const RENTAL_TYPES = [
  {value: '0', label: 'Kısa Kiralama'},
  {value: '1', label: 'Uzun Kiralama'},
  {value: '2', label: 'İkame'},
  {value: '3', label: 'Aylık'},
] as const

export const DELIVERY_TYPES = [
  {value: '0', label: 'Ofis Alış-Teslim'},
  {value: '1', label: 'Adres Alış-Teslim'},
  {value: '2', label: 'Ofis Alış'},
  {value: '3', label: 'Adres Alış'},
  {value: '4', label: 'Ofis Teslim'},
  {value: '5', label: 'Adres Teslim'},
] as const

export const PAYMENT_OWNER = [
  {value: '0', label: 'Müşteri Ödeme'},
  {value: '1', label: 'Full Credit'},
  {value: '2', label: 'Extralar Müşteriye Ait'},
  {value: '3', label: 'Drop Dahil Fatura Firmaya'},
  {value: '4', label: 'Komisyonlu Dosya'},
  {value: '5', label: 'Diğer'},
] as const

export const CALCULATION_TYPES = [
  {value: '0', label: 'Otomatik'},
  {value: '1', label: 'KDV Dahil Günlük'},
  {value: '2', label: 'Günlük'},
  {value: '3', label: 'KDV Dahil Toplam'},
  {value: '4', label: 'Toplam'},
  {value: '5', label: 'KDV Dahil Aylık'},
  {value: '6', label: 'Aylık'},
  {value: '7', label: '30 Gün Dahil Aylık'},
  {value: '8', label: '30 Gün Aylık'},
] as const

export const PAYMENT_TYPES = [
  {value: '0', label: 'KREDI KARTI'},
  {value: '1', label: 'HAVALE'},
  {value: '2', label: 'FATURALAMA-CARİ ÖDEME'},
  {value: '3', label: 'DÖNÜŞTE ÖDEME'},
  {value: '4', label: 'MERKEZ'},
  {value: '5', label: 'BAYİ'},
  {value: '6', label: 'NAKIT'},
  {value: '7', label: 'PEŞİN'},
] as const

export const CURRENCIES = [
  {value: '1', label: 'TL'},
  {value: '2', label: 'EURO'},
  {value: '3', label: 'USD'},
] as const

export const DATE_FILTER_TYPE = [
  {value: '0', label: 'Tarih Önemsiz'},
  {value: '1', label: 'Başlangıç Tarihi'},
  {value: '2', label: 'Bitiş Tarihi'},
  {value: '3', label: 'İşlem Tarihi'},
] as const

export const STOPPAGE_CODES = [
  {value: '', label: 'Yok'},
  {
    value: '616',
    label:
      '616-5018 SAYILI KANUNA EKLİ CETVELLERDEKİ İDARE, KURUM VE KURUŞLARA YAPILAN DİĞER HİZMETLER [GT 117-Bölüm (3.2.13)]',
  },
  {value: '623', label: '623-AĞAÇ VE ORMAN ÜRÜNLERİ TESLİMİ [GT 117-Bölüm (3.3.6)]'},
  {
    value: '619',
    label: '619-BAKIR, ÇİNKO VE ALÜMİNYUM ÜRÜNLERİNİN TESLİMİ [GT 117- Bölüm (3.3.2)]',
  },
  {value: '613', label: '613-ÇEVRE VE BAHÇE BAKIM HİZMETLERİ [GT 117-Bölüm (3.2.10)]'},
  {value: '650', label: '650-DİĞERLERİ'},
  {
    value: '602',
    label: '602-ETÜT, PLAN-PROJE, DANIŞMANLIK, DENETİM VE BENZERİ HİZMETLER [GT 117-Bölüm (3.2.2)]',
  },
  {
    value: '609',
    label:
      '609-FASON OLARAK YAPTIRILAN TEKSTİL VE KONFEKSİYON İŞLERİ, ÇANTA VE AYAKKABI DİKİM İŞLERİ VE BU İŞLERE ARACILIK HİZMETLERİ [GT 117-Bölüm (3.2.7)]',
  },
  {value: '615', label: '615-HER TÜRLÜ BASKI VE BASIM HİZMETLERİ [GT 117-Bölüm (3.2.12)]'},
  {value: '617', label: '617-HURDA METALDEN ELDE EDİLEN KÜLÇE TESLİMLERİ [GT 117- Bölüm (3.3.1)]'},
  {
    value: '618',
    label:
      '618-HURDA METALDEN ELDE EDİLENLER DIŞINDAKİ BAKIR, ÇİNKO VE ALÜMİNYUM KÜLÇE TESLİMLERİ [GT 117-Bölüm (3.3.1)]',
  },
  {
    value: '620',
    label: '620-İSTİSNADAN VAZGEÇENLERİN HURDA VE ATIK TESLİMİ [GT 117- Bölüm (3.3.3)]',
  },
  {value: '606', label: '606-İŞGÜCÜ TEMİN HİZMETLERİ [GT 117-Bölüm (3.2.5)]'},
  {
    value: '603',
    label:
      '603-MAKİNE, TEÇHİZAT, DEMİRBAŞ VE TAŞITLARA AİT TADİL, BAKIM VE ONARIM HİZMETLERİ [GT 117-Bölüm (3.2.3)]',
  },
  {
    value: '621',
    label:
      '621-METAL, PLASTİK, LASTİK, KAUÇUK, KÂĞIT VE CAM HURDA VE ATIKLARDAN ELDE EDİLEN HAMMADDE TESLİMİ [GT 117-Bölüm (3.3.4)]',
  },
  {value: '605', label: '605-ORGANİZASYON HİZMETİ [GT 117-Bölüm (3.2.4)]'},
  {value: '607', label: '607-ÖZEL GÜVENLİK HİZMETİ [GT 117-Bölüm (3.2.5)]'},
  {
    value: '622',
    label:
      '622-PAMUK, TİFTİK, YÜN VE YAPAĞI İLE HAM POST VE DERİ TESLİMLERİ [GT 117-Bölüm (3.3.5)]',
  },
  {value: '614', label: '614-SERVİS TAŞIMACILIĞI HİZMETİ [GT 117-Bölüm (3.2.11)]'},
  {
    value: '611',
    label:
      '611-SPOR KULÜPLERİNİN YAYIN, REKLÂM VE İSİM HAKKI GELİRLERİNE KONU İŞLEMLERİ [GT 117-Bölüm (3.2.9)]',
  },
  {value: '612', label: '612-TEMİZLİK HİZMETİ [GT 117-Bölüm (3.2.10)]'},
  {
    value: '610',
    label:
      '610-TURİSTİK MAĞAZALARA VERİLEN MÜŞTERİ BULMA / GÖTÜRME HİZMETLERİ [GT 117-Bölüm (3.2.8)]',
  },
  {value: '608', label: '608-YAPI DENETİM HİZMETLERİ [GT 117-Bölüm (3.2.6)]'},
  {
    value: '601',
    label:
      '601-YAPIM İŞLERİ İLE BU İŞLERLE BİRLİKTE İFA EDİLEN MÜHENDİSLİK-MİMARLIK VE ETÜT-PROJE HİZMETLERİ [GT 117-Bölüm (3.2.1)]',
  },
  {value: '604', label: '604-YEMEK SERVİS HİZMETİ [GT 117-Bölüm (3.2.4)]'},
] as const

export const COUNTRIES = [
  'Türkiye',
  'Afganistan',
  'Albania',
  'Almanya',
  'Andorra',
  'Angola',
  'Antigua ve Barbuda',
  'Arjantin',
  'Ermenistan',
  'Avustralya',
  'Avusturya',
  'Azerbaycan',
  'Bahamas',
  'Bahreyn',
  'Bangladeş',
  'Barbados',
  'Belarus',
  'Belçika',
  'Belize',
  'Benin',
  'Butan',
  'Bolivya',
  'Bosna-Hersek',
  'Botsvana',
  'Brezilya',
  'Brunei',
  'Bulgaristan',
  'Burkina Faso',
  'Burundi',
  'Kamboçya',
  'Kamerun',
  'Kanada',
  'Yeşil Burun Adaları',
  'Orta Afrika Cumhuriyeti',
  'Çad',
  'Şili',
  'Çin',
  'Kolombiya',
  'Komorlar',
  'Kosta Rika',
  'Fildişi Sahili',
  'Küba',
  'Kıbrıs',
  'Çekya',
  'Kongo Cumhuriyeti',
  'Demokratik Kongo Cumhuriyeti',
  'Danimarka',
  'Cibuti',
  'Dominika',
  'Dominik Cumhuriyeti',
  'Doğu Timor',
  'Ekvador',
  'Mısır',
  'El Salvador',
  'Ekvator Ginesi',
  'Eritre',
  'Estonya',
  'Etiyopya',
  'Fiji',
  'Finlandiya',
  'Fransa',
  'Gabon',
  'Gambiya',
  'Gürcistan',
  'Gana',
  'Gine',
  'Gine-Bissau',
  'Grenada',
  'Guatemala',
  'Guyana',
  'Haiti',
  'Hindistan',
  'Endonezya',
  'İran',
  'Irak',
  'İrlanda',
  'İsrail',
  'İsveç',
  'İsviçre',
  'İtalya',
  'Jamaika',
  'Japonya',
  'Ürdün',
  'Kazakistan',
  'Kenya',
  'Kırgızistan',
  'Laos',
  'Letonya',
  'Lübnan',
  'Lesotho',
  'Liberya',
  'Libya',
  'Lihtenştayn',
  'Litvanya',
  'Lüksemburg',
  'Madagaskar',
  'Malavi',
  'Malezya',
  'Maldivler',
  'Mali',
  'Malta',
  'Marshall Adaları',
  'Moritanya',
  'Mauritius',
  'Meksika',
  'Mikronezya',
  'Moldova',
  'Monako',
  'Moğolistan',
  'Karadağ',
  'Fas',
  'Mozambik',
  'Myanmar',
  'Namibya',
  'Nauru',
  'Nepal',
  'Hollanda',
  'Yeni Zelanda',
  'Nikaragua',
  'Nijer',
  'Nijerya',
  'Kuzey Kore',
  'Norveç',
  'Umman',
  'Pakistan',
  'Palau',
  'Filistin',
  'Panama',
  'Papua Yeni Gine',
  'Paraguay',
  'Peru',
  'Filipinler',
  'Polonya',
  'Portekiz',
  'Katar',
  'Romanya',
  'Rusya',
  'Ruanda',
  'Suudi Arabistan',
  'Senegal',
  'Sırbistan',
  'Sierra Leone',
  'Singapur',
  'Slovakya',
  'Slovenya',
  'Solomon Adaları',
  'Somali',
  'Güney Afrika',
  'Güney Kore',
  'Güney Sudan',
  'İspanya',
  'Sri Lanka',
  'Sudan',
  'Surinam',
  'Svaziland',
  'Tunus',
  'Türkmenistan',
  'Tuvalu',
  'Uganda',
  'Ukrayna',
  'Amerika Birleşik Devletleri',
  'Uruguay',
  'Özbekistan',
  'Vanuatu',
  'Venezuela',
  'Vietnam',
  'Yemen',
  'Zambiya',
  'Zimbabve',
] as const

export const COUNTRY_OPTIONS = COUNTRIES.map((country, index) => ({
  value: (index + 1).toString(),
  label: country,
}))
